module.exports = __webpack_public_path__ + "static/chilli-beans-1-a968e10944cbcb25054e828e21556066.jpg";